import styled from "styled-components";
import range from "lodash/range";
import { useEffect, useState } from "react";

interface Props {
  onChange?: (arg: { year: number; month: number; day: number }) => void;
}

const years = range(2021, 1929);
const months = range(1, 13);
const days = range(1, 32);

const DateSelect = (props: Props) => {
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [day, setDay] = useState(0);

  const { onChange } = props;

  const onChangeYear = (event: any) => setYear(event.target.value);
  const onChangeMonth = (event: any) => setMonth(event.target.value);
  const onChangeDay = (event: any) => setDay(event.target.value);

  useEffect(() => {
    if (!onChange) return;
    onChange({ year, month, day });
  }, [year, month, day, onChange]);

  return (
    <div tw="flex items-center justify-between">
      <Select value={year} onChange={onChangeYear}>
        {years.map((year: number) => (
          <Option key={year}>{year}</Option>
        ))}
      </Select>
      <Label>年</Label>
      <Select value={month} onChange={onChangeMonth}>
        {months.map((month: number) => (
          <Option key={month}>{month}</Option>
        ))}
      </Select>
      <Label>月</Label>
      <Select value={day} onChange={onChangeDay}>
        {days.map((day: number) => (
          <Option key={day}>{day}</Option>
        ))}
      </Select>
      <Label>日</Label>
    </div>
  );
};

export default DateSelect;

const Select = styled.select`
  background: #fff;
  opacity: 0.57;
  padding: 8px;
  border-radius: 0;
  margin-right: 8px;
  cursor: pointer;
`;

const Option = styled.option`
  cursor: pointer;
`;

const Label = styled.span`
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 24px;
  color: #fff;
  margin-right: 8px;
`;
